import {
  Component,
  inject,
  Input,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { MultiDynamicTable } from '@shared/components/atomics/so-multi-dynamic-table/dynamic-table.component';
import { TableConfig, TableData } from '@core/interfaces/table.interface';
import { ModalService } from '@modules/cotizaciones/services/modal-service';
import { DashboardWhatsappService } from '../../service/dashboard-whatsapp.service';
import { ActivatedRoute } from '@angular/router';
import {
  AlertType,
  DynamicComponentService,
} from '@shared/components/atomics/body-loading/dynamic-component-service.service';
import { ModalDetalleMensajesComponent } from '../modal-detalle-mensajes/modal-detalle-mensajes.component';

@Component({
  selector: 'app-modal-conversations',
  standalone: true,
  imports: [SharedModule, MultiDynamicTable, ModalDetalleMensajesComponent],
  templateUrl: './modal-conversations.component.html',
  styleUrl: './modal-conversations.component.scss',
})
export class ModalConversationsComponent {
  private modalService = inject(ModalService);
  private dashboardWhatsService = inject(DashboardWhatsappService);
  private dynamicComponentService = inject(DynamicComponentService);

  constructor(private route: ActivatedRoute) {}
  urlMessages = signal<String>('');
  config: TableConfig = {
    pagination: {
      enabled: true,
      pageSize: 10,
      pageSizeOptions: [5, 10, 25, 50, 100],
    },
    filtering: {
      enabled: true,
      placeholder: 'Buscar ...',
    },
    sorting: {
      enabled: true,
    },
  };

  @Input() data = [];
  @Input() title: string = '';

  columns: any = [
    {
      key: 'prospecto',
      title: 'PROSPECTO',
      type: 'text',
      width: '250px',
      sortable: true,
      filterable: true,
    },
    // {
    //   key: 'registro',
    //   title: 'REGISTRO',
    //   type: 'badge',
    //   width: '100px',
    //   sortable: true,
    //   badgeConfig: {
    //     colorMap: {
    //       Registrado: 'status-registered',
    //       'Sin Registrar': 'status-unregistered',
    //     },
    //   },
    // },
    {
      key: 'mensajes',
      title: 'MENSAJES',
      type: 'badge-circle',
      click: true,
      width: '100px',
      sortable: true,
      badgeConfig: {
        colorMap: {
          '1': 'so-bg-secondary',
          '2': 'so-bg-secondary',
          '3': 'so-bg-secondary',
          '4': 'so-bg-secondary',
          '0': 'so-bg-primary',
        },
      },
    },
    {
      key: 'tiempo_sin_respuesta',
      title: 'TIEMPO SIN RESPUESTA',
      type: 'text',
      width: '180px',
      sortable: true,
    },
    {
      key: 'tiempo_sin_respuesta_cliente',
      title: 'TIEMPO SIN RESPUESTA CLIENTE',
      type: 'text',
      width: '220px',
      sortable: true,
    },
    // {
    //   key: 'acciones',
    //   title: 'ACCIONES',
    //   type: 'button',
    //   width: '120px',
    //   buttonConfig: {
    //     text: 'Ver',
    //     action: 'view',
    //     class: 'btn-primary',
    //   },
    // },
  ];

  onButtonClick(event: { action: string; data: any }) {
    const data = event.data;
    console.log('URL: ', data);

    const queryParams = this.route.snapshot.queryParamMap;
    this.dashboardWhatsService
      .getUrlRedirect(
        queryParams.get('IdDistribuidor')!,
        queryParams.get('IdMarca')!,
        queryParams.get('eMail')!,
        queryParams.get('RegistryId')!,
        queryParams.get('Token')!,
        data?.idProspecto!
      )
      .subscribe(
        (datos) => {
          this.urlMessages.set(datos.url)
          this.modalService.closeModal('modal-conversations-wts');
          this.modalService.openModal('modal-detalle-mensajes');
        },
        (err) => {
          this.dynamicComponentService.showAlert({
            alertType: AlertType.error,
            message: 'Ocurrio un error al buscar la conversación',
            animate: true,
            autohide: true,
          });
        }
      );
  }

  onLinkClick(event: { data: any }) {}

  onClose() {
    this.modalService.closeModal('modal-conversations-wts');
  }
}
